import { useNavigate } from "react-router-dom";

import { useCompany } from "#modules/company/view/useCompany";
import {
  getOnboardingMaterialMode,
  ONBOARDING_STEP_COUNT,
  ONBOARDING_STEPS,
  type OnboardingStepContext,
  type OnboardingStepId,
} from "#modules/onboardingV2/domain/onboardingSteps";
import { useOnboardingAnalytics } from "#modules/onboardingV2/view/useOnboardingAnalytics";
import { AnalyticsEvent } from "#shared/useAnalytics";

type OnboardingStepContextOverrides = Partial<OnboardingStepContext>;

export const useOnboardingStepNavigation = (
  stepId: OnboardingStepId,
  overrides: OnboardingStepContextOverrides = {},
) => {
  const navigate = useNavigate();
  const { company } = useCompany();
  const { captureOnboardingEvent } = useOnboardingAnalytics(stepId);
  const step = ONBOARDING_STEPS[stepId];

  const context: OnboardingStepContext = {
    materialMode:
      "materialMode" in overrides
        ? (overrides.materialMode ?? null)
        : company
          ? getOnboardingMaterialMode(company.companySettings)
          : null,
    hasProcessSteps: overrides.hasProcessSteps ?? false,
  };

  return {
    position: step.position,
    total: ONBOARDING_STEP_COUNT,
    goToNext: () => navigate(step.next(context)),
    goToPrevious: () => {
      captureOnboardingEvent(AnalyticsEvent.OnboardingStepBack);
      navigate(step.prev(context));
    },
  };
};
